import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {DumpsterFireGameAssets} from "../DumpsterFireGameAssets";
import {DumpsterFire} from "../DumpsterFire";
import {TimelineLite, gsap} from "gsap";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";
import {DFBigWinRunner} from "../presentation/baseGame/DFBigWinRunner";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class DFBigWinView extends PIXI.Container implements StageLayer {

    private _countUp: BasicBitmapCountUp;
    private _maxLevel: number;
    private _bigWinSpineMap: Map<number, PIXI.spine.Spine> = new Map();

    constructor() {
        super();
        this.name = "DFBigWinView";
        this.init();
    }

    public set maxLevel(value: number) {
        this._maxLevel = value;
    }

    private createLevelSpine(level: number): PIXI.spine.Spine {
        let spineName: string = "bigWin_level" + level + (DumpsterFire.isUSJurisdiction && level === 4 ? "_US" : "");
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset(spineName));
        spine.position.set(360, 360);
        this.addChild(spine);
        spine.visible = false;
        return spine;
    }

    public getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number, index: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            spine: PIXI.spine.Spine | undefined = this._bigWinSpineMap.get(level);
        DFBigWinRunner._bigWinSound = DumpsterFireSound.BIG_WIN_LEVEL + (index + 1);
        if (spine) {
            tl.add([() => {
                spine.visible = true;
                spine.state.timeScale = 1;
            }, DumpsterFire.createTimelineForAnimation(spine, 0, "animation", false)], 0);
        }
        tl.add([
            () => {
                if (level === 1) {
                    this.alpha = 1;
                    this._countUp.visible = true;
                }
            },
            this._countUp.getCountAnimation(countFrom, countTo, duration - 0.2),
        ], 0);
        tl.add(this.getCountUpScaleAnimation(0.2, "power2.in", 1.3), `${duration - 0.3}`);
        tl.add(this.getCountUpScaleAnimation(0.1, "power2.out", 1.0));
        // tl.add(gsap.to(this, {duration: 0.2}));
        // tl.add(gsap.to(this, {duration: 0.2}));
        return tl;
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._countUp.position.set(360, 580);
        } else {
            this._countUp.position.set(360, 670);
        }
    }

    private init(): void {
        const container: PIXI.Container = new PIXI.Container();
        for (let level: number = 1; level <= 5; level++) {
            this._bigWinSpineMap.set(level, this.createLevelSpine(level));
        }
        this._countUp = new BasicBitmapCountUp({
            fontName: DumpsterFireGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60,
        }, 580, new PIXI.Point(0.5, 0.5));
        this._countUp.visible = false;
        this.onResize();
        this.addChild(container, this._countUp);
        this.hide();
    }

    private getCountUpScaleAnimation(duration: number, ease: string, to: number, from?: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (from != undefined) {
            tl.add(() => {
                this._countUp.scale.set(from, from)
            });
        }
        tl.to(this._countUp.scale, {duration: duration, x: to, y: to, ease: ease});
        return tl;
    }

    public hide(duration: number = 0.0001): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this, {duration: duration, alpha: 0});
        this._bigWinSpineMap.forEach((spine: PIXI.spine.Spine) => {
            spine.visible = false;
        });
        return tl;
    }

    public resetBigWinAnim(): void {
        for (let i: number = 1; i <= 5; i++) {
            let resetBWSpine: PIXI.spine.Spine | undefined = this._bigWinSpineMap.get(i);

            if (resetBWSpine) {
                resetBWSpine.state.clearTracks();
                resetBWSpine.skeleton.setToSetupPose();
                resetBWSpine.skeleton.setSlotsToSetupPose();
            }
        }
    }
}